module.exports = __webpack_public_path__ + "teqbahn-assets/media/Dr Abednego Kinasha.a8e7dd45.jpg";